import store from '@/state/store'

export default [
    {
        path: '/',
        name: 'Dashboard',
        meta: { requiresAuth: true },
        component: () => import('../views/pages/dashboard')
    },
    {
        path: '/login',
        name: 'login',
        meta: { requiresAuth: false },
        component: () => import('../views/pages/auth/login')
    },
    {
        path: '/plugin/voices/list',
        name: 'PluginVoiceList',
        meta: { requiresAuth: true },
        component: () => import('../views/pages/plugin/voices/list.vue')
    },
    {
        path: '/plugin/voices/items/:itemId',
        name: 'PluginVoiceList2',
        meta: { requiresAuth: true },
        component: () => import('../views/pages/plugin/voices/items.vue')
    },
    {
        path: '/plugin/voices/topics/:itemId',
        name: 'PluginVoiceList2',
        meta: { requiresAuth: true },
        component: () => import('../views/pages/plugin/voices/topics.vue')
    },
    {
        path: '/manager/list',
        name: 'ManagerList',
        meta: { requiresAuth: true },
        component: () => import('../views/pages/managers.vue')
    },
    {
        path: '/users/records/user/list',
        name: 'RecordList',
        meta: { requiresAuth: true },
        component: () => import('../views/pages/records/users/list.vue')
    },
    {
        path: '/users/records/user/item/:itemId',
        name: 'RecordItem',
        meta: { requiresAuth: true },
        component: () => import('../views/pages/records/users/item.vue')
    },
    {
        path: '/users/records/unit/list',
        name: 'RecordUnitList',
        meta: { requiresAuth: true },
        component: () => import('../views/pages/records/unit/list.vue')
    },
    {
        path: '/users/records/unit/item/:itemId',
        name: 'RecordUnitItem',
        meta: { requiresAuth: true },
        component: () => import('../views/pages/records/unit/item.vue')
    }
]